import { Observable } from 'rxjs';
import { Delete } from '../../../domain/repositories/general/delete.interface';
import { CRUDHnadler } from '../../../domain/repositories/general/crud.handler';

/**
 *Casos de uso de la entidad Socio que realizara acciones a nivel de aplicación cuando se realice la acción de eliminación 

 *
 * @export
 * @class DeleteSocioUseCase
 * @implements {Delete}
 */
export class DeleteSocioUseCase implements Delete {
  constructor(private crudHandler: CRUDHnadler) {}

  public delete(id: number): Observable<boolean> {
    return this.crudHandler.deleteById(id);
  }
}
